module.exports = __webpack_public_path__ + "img/issued_tickets.944eb7fc.svg";